import { render, staticRenderFns } from "./PerformanceTable.vue?vue&type=template&id=0e2c57b6&"
import script from "./PerformanceTable.vue?vue&type=script&lang=js&"
export * from "./PerformanceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports